import { ExperienceTemplateRenderer, TemplateComponent, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { UitkLayoutGrid } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';

export interface ResultsWrapperProps extends TemplateComponentProps {
  templateComponent: TemplateComponent;
}

export const ResultsWrapper: React.FC<ResultsWrapperProps> = ({ templateComponent }) => {
  const { children } = templateComponent;

  if (!children || children.length === 0) {
    return null;
  }

  return (
    <UitkSpacing padding={{ small: { block: 'three' }, medium: { blockstart: 'one' }, large: { blockstart: 'three' } }}>
      <div className="search-results-listing">
        <Viewport>
          <ViewLarge>
            <UitkLayoutGrid columns={4} space="six">
              {children && <ExperienceTemplateRenderer templateComponents={children} />}
            </UitkLayoutGrid>
          </ViewLarge>
          <ViewSmall>
            <UitkLayoutGrid columns={1}>{children && <ExperienceTemplateRenderer templateComponents={children} />}</UitkLayoutGrid>
          </ViewSmall>
        </Viewport>
      </div>
    </UitkSpacing>
  );
};
